import {default as scroll} from './modules/_scroll';
import {default as header} from './modules/_header';
import {default as tiles} from './modules/_tiles';
import {default as emotionText} from './modules/_emotion-text';

(function () {
	scroll.init();
	header.init();
	tiles.init();
  	emotionText.init();
})();